












import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class YoutubeVideo extends Vue {
	@Prop() private videoId!: string;
	@Prop() private width?: string;
	@Prop() private height?: string;

	static readonly defaultWidth: string = "633";
	static readonly defaultHeight: string = "506";
	static readonly defaultRatio: number = 506 / 633;

	get urlVideoSource(): string {
		return "https://www.youtube.com/embed/" + this.videoId;
	}

	get widthToUse(): string {
		return this.width !== undefined ? this.width : YoutubeVideo.defaultWidth;
	}

	get heightToUse(): string {
		return this.height !== undefined
			? this.height
			: YoutubeVideo.defaultHeight;
	}
}
